// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';


const requiredPart = t.interface({
  tag: t.string,
});

export const ValidateAssociationBindingAdminBaseObjectSchema = excess(requiredPart);

export interface ValidateAssociationBindingAdminBaseObject extends t.TypeOf<typeof ValidateAssociationBindingAdminBaseObjectSchema> {}
